import {
    GuiaActionTypes,
    SET_GUIA_DESTINO,
    SET_GUIA_ORIGEN,
    SET_GUIA_WIZARD,
    SET_GUIA_MERCANCIAS,
    SET_GUIA_MERCANCIAS_COMPLEMENTARIAS,
    SET_GUIA_SERVICIOS,
    RESET_GUIA_NUEVA,
    SET_GUIA_CONSULTA,
    CLEAR_GUIA_CONSULTA
} from "../types/guiaActionTypes";
import { IRecoleccion } from "../types/recoleccionActionTypes";
import { derivarOficinaLogin, IGuiaWizard } from "../../entities/guias/IGuiaWizard";
import { IGuiaConsultaDto } from "../../entities/guias/IGuiaConsultaDto";
import { Mercancia } from "../../entities/solicitudes/Mercancia";
import { ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { MercanciaDatosComplementarios } from "../../entities/solicitudes/MercanciaDatosComplementarios";
import { markGuiaTarifaDirty } from "./guiaTarifaActions";
import { ApplicationState } from "../reducers";

const wizardAfectaTarifa = (prev: IGuiaWizard, next: IGuiaWizard): boolean => {
    return prev.remitenteId !== next.remitenteId
        || prev.destinatarioId !== next.destinatarioId
        || prev.sucursalRemitenteId !== next.sucursalRemitenteId
        || prev.esEad !== next.esEad
        || prev.esOcurreDestino !== next.esOcurreDestino
        || prev.unidadMedidaPesoId !== next.unidadMedidaPesoId
        || prev.unidadMedidaLongitudId !== next.unidadMedidaLongitudId
        || prev.tipoServicioId !== next.tipoServicioId
        || prev.tipoEnvioId !== next.tipoEnvioId
        || prev.esSeguroBasico !== next.esSeguroBasico
        || prev.esSeguroMercancia !== next.esSeguroMercancia
        || prev.valorMercancia !== next.valorMercancia;
};

export function setGuiaWizard(wizard: IGuiaWizard) {
    return (dispatch, getState: () => ApplicationState) => {
        const prev = getState().guiaWizard;
        const sucursalRemitenteId = wizard.sucursalRemitenteId || 0;
        const normalized: IGuiaWizard = {
            ...wizard,
            sucursalRemitenteId,
            oficinaLogin: derivarOficinaLogin(sucursalRemitenteId)
        };
        dispatch({
            type: SET_GUIA_WIZARD,
            wizard: normalized
        } as GuiaActionTypes);
        if (wizardAfectaTarifa(prev, normalized)) {
            dispatch(markGuiaTarifaDirty());
        }
    };
}

export function setGuiaOrigen(recoleccion: IRecoleccion) {
    return (dispatch) => {
        dispatch({
            type: SET_GUIA_ORIGEN,
            recoleccion
        } as GuiaActionTypes);
        dispatch(markGuiaTarifaDirty());
    };
}

export function setGuiaDestino(recoleccion: IRecoleccion) {
    return (dispatch) => {
        dispatch({
            type: SET_GUIA_DESTINO,
            recoleccion
        } as GuiaActionTypes);
        dispatch(markGuiaTarifaDirty());
    };
}

export function setGuiaMercancias(mercancias: Mercancia[]) {
    return (dispatch) => {
        dispatch({
            type: SET_GUIA_MERCANCIAS,
            mercancias
        } as GuiaActionTypes);
        dispatch(markGuiaTarifaDirty());
    };
}

export function setGuiaMercanciasComplementarias(mercanciasComplementarias: MercanciaDatosComplementarios[]) {
    return (dispatch) => {
        dispatch({
            type: SET_GUIA_MERCANCIAS_COMPLEMENTARIAS,
            mercanciasComplementarias
        } as GuiaActionTypes);
    };
}

export function setGuiaServicios(servicios: ServicioAdicional[]) {
    return (dispatch) => {
        dispatch({
            type: SET_GUIA_SERVICIOS,
            servicios
        } as GuiaActionTypes);
        dispatch(markGuiaTarifaDirty());
    };
}

export function resetGuiaNueva(): GuiaActionTypes {
    return {
        type: RESET_GUIA_NUEVA
    };
}

export function setGuiaConsulta(consulta: IGuiaConsultaDto): GuiaActionTypes {
    return {
        type: SET_GUIA_CONSULTA,
        consulta
    };
}

export function clearGuiaConsulta(): GuiaActionTypes {
    return {
        type: CLEAR_GUIA_CONSULTA
    };
}
